import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './JoinButton.module.css';

/**
 * JoinButton - Unified button component for Join Crew / Join LinkUp actions
 *
 * @param {boolean} isJoined - Whether the user has joined
 * @param {string} joinText - Text when not joined (e.g., "Join Crew", "Join LinkUp")
 * @param {string} joinedText - Text when joined (e.g., "Take me there")
 * @param {Function} onClick - Click handler
 * @param {string} className - Additional CSS classes
 * @param {string} size - Button size: 'small', 'medium', 'large'
 */
const JoinButton = ({
  isJoined = false,
  joinText = 'Join',
  joinedText = 'Take me there',
  onClick,
  className,
  size = 'medium',
  ...rest
}) => {
  const buttonClasses = classNames(
    css.joinButton,
    css[size],
    {
      [css.joined]: isJoined,
    },
    className
  );

  return (
    <button className={buttonClasses} onClick={onClick} {...rest}>
      {isJoined ? joinedText : joinText}
    </button>
  );
};

JoinButton.propTypes = {
  isJoined: PropTypes.bool,
  joinText: PropTypes.string,
  joinedText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default JoinButton;
